import { render, staticRenderFns } from "./to-contact.vue?vue&type=template&id=b1f7882a&scoped=true"
import script from "./to-contact.vue?vue&type=script&lang=js"
export * from "./to-contact.vue?vue&type=script&lang=js"
import style0 from "./to-contact.vue?vue&type=style&index=0&id=b1f7882a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f7882a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/whitewe_jisheng-mes-ui_CPvN/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1f7882a')) {
      api.createRecord('b1f7882a', component.options)
    } else {
      api.reload('b1f7882a', component.options)
    }
    module.hot.accept("./to-contact.vue?vue&type=template&id=b1f7882a&scoped=true", function () {
      api.rerender('b1f7882a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home-page/components/to-contact.vue"
export default component.exports